import { CommonModule } from '@angular/common';
import { Component, ElementRef, input, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'abb-card',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  template: `
    <mat-card
      [ngClass]="[cardHeight() ?? 'min-h-[88%]', cardWidth() ?? 'w-[550px]']"
      class="!mat-elevation-z8 !shadow-abb-gray-03 bg-abb-background !rounded-[2%] py-6 px-12 flex flex-col gap-4 max-w-auto max-h-[calc(100%-6rem)] mx-auto my-auto overflow-hidden"
    >
      <mat-card-header>
        <mat-card-title>
          <ng-content #titleRef select="[card-title]" />
          @if(!titleRef) {
            <span class="text-3xl font-semibold min-h-9 text-abb-primary leading-none p-0 m-0">—</span
            >
          <h1 class="text-3xl font-semibold">
            <span>{{
              cardTitle().slice(0, 3)
            }}</span
            >{{ cardTitle().slice(3) }}
          </h1>
          }
        </mat-card-title>
        @if(cardSubtitle()){
        <mat-card-subtitle>
          <h2 class="text-2xl font-medium">
            {{ cardSubtitle() }}
          </h2>
        </mat-card-subtitle>
        }
      </mat-card-header>
      <mat-card-content class="!flex !flex-col !flex-1 !overflow-auto">
        <ng-content select="[card-content]"></ng-content>
      </mat-card-content>
      <mat-card-actions class="justify-center">
        <ng-content #cardActionsRef select="[card-actions]"></ng-content>
      </mat-card-actions>
    </mat-card>
  `,
  styles: ``,
  host: {
    class: 'block w-full h-full content-center py-8 pr-8 overflow-auto',
  },
})
export class AbbCardComponent {
  @ViewChild('titleRef') titleRef: ElementRef | undefined;
  cardTitle = input<string>('');
  cardSubtitle = input<string | undefined>(undefined);
  cardHeight = input<string | undefined>(undefined);
  cardWidth = input<string | undefined>(undefined);
}
